export default {
    statuses: {
        OPEN: 'PENDING',
        OUT_OF_TIME: 'FOR RESCHEDULE',
        ACCEPTED: 'ACCEPTED',
        DECLINED: 'DECLINED',
        CANCELED: 'CANCELED',
        DONE: 'COMPLETED',
        DONE_BY_CRON: 'COMPLETED',
        UNAVAILABLE: 'UNAVAILABLE',
        NO_SHOW: 'NO SHOW',
    },
    actions: {
        ACCEPT: 'ACCEPT',
        DECLINE: 'DECLINE',
        CANCEL: 'CANCEL',
        RESCHEDULE: 'RESCHEDULE',
        MAKE_UNAVAILABLE: 'MAKE UNAVAILABLE',
        VIEW: 'VIEW',
        UNAVAILABLE: 'Cancel and set time slot unavailable',
        DONE: 'SHOWED UP',
        NO_SHOW: 'NO SHOW',
        FINISH: 'FINISH',
        FINISH_EARLY: 'SHORTEN BOOKING',
        REMOVE_FINISH_EARLY: 'REMOVE SHORTEN BOOKING',
    },
    modal: {
        cancel_heading: 'Are you sure you want to cancel?',
        decline_or_make_unavailable: 'Decline, or decline and make a slot unavailable?',
        cancel_or_make_unavailable: 'Are you sure you want to cancel the reservation?',
        no_show_headling: 'Did user show up?',
        finish_early_heading: 'Finish early',
        finish_early_description:
            "Adjust the end time of this event to allow subsequent bookings to start earlier. Set how many minutes after the start time you'll be available for the next booking..",
        finish_early_chose: 'Choose time',
        remove_finish_early_modal: 'Are you sure you want to remove finish early time?',
    },
}
